import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
		x: 10,
		y: 1,
		width: 5,
		height: 14,
		rx: 1.5
	}), /* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 5,
		height: 14,
		rx: 1.5
	})] })
});
const ForwardRef = forwardRef(SvgPause);
export { ForwardRef as ReactComponent };
